import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef, CSSProperties } from 'react';
import './badge.scss';

const badgeVariants = cva('badge', {
    variants: {
        variant: {
            default: 'badge--default',
            secondary: 'badge--secondary',
            tertiary: 'badge--tertiary',
            darkWarning: 'badge--dark-warning',
            success: 'badge--success',
            customColor: 'badge--custom-color',
            error: 'badge--error',
        },
        appearance: {
            fill: 'badge--fill',
            outline: 'badge--outline',
        },
        shape: {
            rounded: 'badge--rounded',
        },
    },
    defaultVariants: {
        appearance: 'fill',
        variant: 'default',
    },
});

type Props = ComponentPropsWithRef<'span'> &
    VariantProps<typeof badgeVariants> & { asChild?: boolean; customColor?: string };
export const Badge = ({
    className,
    variant,
    appearance,
    shape,
    customColor,
    asChild = false,
    ...props
}: Props) => {
    const Comp = asChild ? Slot : 'span';
    return (
        <Comp
            data-variant={variant}
            className={badgeVariants({ appearance, variant, shape, className })}
            style={customColor ? ({ ['--custom-badge-color']: customColor } as CSSProperties) : undefined}
            {...props}
        />
    );
};
